// extracted by mini-css-extract-plugin
export default {"bookingSuccess":"BookingSuccess_bookingSuccess__vrF6V"};